import { allFilms } from "./allFilms";

export const weddingFilms = allFilms.filter(function(obj) { return obj.type === 'Casamento'; });